export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11289.477c1d1f.jpg";